module.exports = __webpack_public_path__ + "static/media/99BoyfriendsofMicahSummersBookCover.a38867b9.jpg";